import {ApplicationScope} from "./ApplicationScope";
import {Environment} from "./config";

/*
Checks that the carestream server version required by flynotes matches what is currently installed.

If not, it installs the required version and restart the process
 */
export const ensureCarestreamVersion = async ({logging, flynotesServer, npm, licenceKey, config}: ApplicationScope): Promise<void> => {
  return;
  const licenceKeyData = await flynotesServer.getLicenceKeyData(licenceKey);
  const currentCarestreamServerVersion = await npm.currentCarestreamServerVersion();

  const expectedCarestreamServerVersion = licenceKeyData.libraryVersion;

  if (currentCarestreamServerVersion !== expectedCarestreamServerVersion) {
    logging.log({
      message: `carestream-server is out of sync. Expected ${expectedCarestreamServerVersion} but at ${currentCarestreamServerVersion}`
    });

    // Don't update if we're running in 'development mode' on a dev server, as
    // we probably want to just use whatever version we're testing
    if (config.environment === Environment.prod && !process.env['DEVELOPMENT_MODE']) {
      await npm.updateLibrary('@flynotes/carestream-server', expectedCarestreamServerVersion);
      process.exit(0);
    }
  }
};
